import { v4 } from 'uuid';
import PropTypes from 'prop-types';
import React from 'react';

class UuidControl extends React.Component {

  render() {

    const {
      forID,
      value,
      onChange,
      classNameWrapper,
    } = this.props;

    let tmpval = null
    if (typeof value === "undefined" || value === "") {
      tmpval = v4();
      onChange(tmpval)
    }
    return (
      <>
        <input
          type="hidden"
          id={forID}
          className={classNameWrapper}
          value={value}
        />
        <div>{value}</div>
      </>
    );
  }
}

UuidControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  forID: PropTypes.string,
  value: PropTypes.node,
  classNameWrapper: PropTypes.string.isRequired,
}


function UuidPreview({ value }) {
  return <div>{value}</div>;
}

UuidPreview.propTypes = {
  value: PropTypes.node,
};


export { UuidControl, UuidPreview }